<template>
  <label>{{ displayName || fieldName | unsnake | capitalize }}:
    <fct-select :disabled="disabled" :searchable="false" @input="doFilter($event)" :options="selectOptions"
                v-model="inputVal"></fct-select>
  </label>
</template>

<script>
import chainableVModel from "../../mixins/chainableVModel";
import {get} from "lodash"

export default {
  props: {
    fieldName: String,
    displayName: String,
    filterManager: Object,
    options: {
      default: []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryMapper: {
      type: Object,
      default: () => ({})
    },
    searchable: {
      type: Boolean,
      default: false
    },
  },
  mixins: [chainableVModel],
  methods: {
    doFilter(key = this.value || '') {
      if (key === 'All') {
        this.filterManager.setFilter(this.fieldName)
      } else {
        let val2 = Array.isArray(this.options) ? key : this.options[key]
        this.filterManager.setFilter(this.fieldName,
          (o) => {
            let val1 = get(o, this.fieldName)
            console.log({val1, val2})
            return Array.isArray(val1) ? val1.includes(val2) : val1 === this.options[key]
          },
          {[this.fieldName]: this.queryMapper[val2] || val2})
      }
    }
  },
  computed: {
    selectOptions () {
      return Array.isArray(this.options) ? this.options : Object.keys(this.options)
    }
  },
  mounted() {
    this.doFilter()
  }
}
</script>

<style scoped>

</style>
